import { useFragmentsViewCapture } from '@app/modules/fragments/hooks/useFragmentsViewCapture';
import { buildLoggerStreamUrl } from '@app/modules/logger/screens/stream/helpers/build-logger-stream-url';
import { DateTimeStr, toTimestamp } from '@mi-front/core';
import StartIcon from '@mui/icons-material/Start';
import { defineMessage, useIntl } from 'react-intl';
import { FragmentLoggerActionButton } from './FragmentLoggerActionButton';

const goToStreamMessage = defineMessage({
  id: 'fragments.view.metadata.goToStream',
  defaultMessage: 'Inicio',
});

type FragmentGoToStreamFromStartActionProps = {
  stationSlug: string;
  fragmentFrom: DateTimeStr;
};

/**
 * Opens logger stream at the fragment start timestamp.
 */
export function FragmentGoToStreamFromStartAction({
  stationSlug,
  fragmentFrom,
}: FragmentGoToStreamFromStartActionProps) {
  const { $t } = useIntl();
  const fragmentsCapture = useFragmentsViewCapture();
  const loggerStreamUrl = buildLoggerStreamUrl(stationSlug, {
    cursor: toTimestamp(fragmentFrom),
  });
  const handleClick = () => {
    fragmentsCapture.goToStreamFromStart({
      stationSlug,
      fragmentFrom,
    });
  };

  return (
    <FragmentLoggerActionButton
      to={loggerStreamUrl}
      onClick={handleClick}
      startIcon={<StartIcon fontSize="small" />}
    >
      {$t(goToStreamMessage)}
    </FragmentLoggerActionButton>
  );
}
